import {
    BACK_ORDERS_RECEIVE,
    BACK_ORDERS_ERROR,
} from '../ConstantsBrafab/constants';

import { error as errorReducer } from '../Reducers/Error.reducer';

const defaultState = {
    list: [],
    totalRemainingCost: 0,
    totalRemainingVolume: 0
};

export const backOrder = (state = defaultState, action) => {
    const { type, payload } = action;
    switch (type) {
        case BACK_ORDERS_RECEIVE:
            return {
                ...state,
                errors: {},
                ...payload,
            };
        case BACK_ORDERS_ERROR:
            return {
                ...state,
                errors: errorReducer(state.errors, action),
            };
        default:
            return state;
    }
};
